import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useCurrentTrial } from '../../../hooks/useActiveTrials';
import { useAppSelector } from '../../../reducers';
import { getIsLatestVersionOfProductInProductInventorySelector, ownedBundleProductContainingHubSelector } from '../../../selectors/ProductInventorySelectors';
import { productSelector, productVersionSelector } from '../../../selectors/ProductsSelectors';
import { useFTS0017orFTS0018ExperimentEffect } from '../../../utils/experiments/fts0017_fts0018';
import { useSkuAdditionalUnits } from '../../merch-card/useSkuAdditionalUnits';
import CurrentPlanTag from './CurrentPlanTag';
import { CurrentTrialBadge } from './CurrentTrialBadge';
import { RecommendedBadge } from './RecommendedBadge';

/**
 * @description
 * This component is responsible for rendering only one badge at a time as we don't want to show multiple badges at once. This is similar to our BannerHierarchy component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const HubCardBadge = ({
  productLine,
  productLevel
}) => {
  const isAppReady = useGlobalLoading();
  const product = useSelector(state => productSelector(state, {
    productLine,
    productLevel
  }));
  const apiName = product && product.apiName;
  const currentTrial = useCurrentTrial(apiName);
  const {
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const isCurrentPlan = useAppSelector(state => isAppReady && getIsLatestVersionOfProductInProductInventorySelector(state, {
    productIdentifier: {
      apiName
    }
  }));
  const {
    loading: isLoadingFTS0017orFTS0018Experiment,
    variant: isInFTS0017orFTS0018ExperimentVariant
  } = useFTS0017orFTS0018ExperimentEffect();
  const ownedBundleProductContainingHub = useAppSelector(state => {
    if (!isAppReady) return;
    return ownedBundleProductContainingHubSelector(state, {
      skuId
    });
  });
  const bundleType = useAppSelector(state => {
    if (!ownedBundleProductContainingHub) return;
    return productVersionSelector(state, {
      skuId: ownedBundleProductContainingHub.skuId
    }).bundleType;
  });
  const ownsProductViaBundle = !!ownedBundleProductContainingHub;
  const showFTS0017orFTS0018ExperimentFeatures = isInFTS0017orFTS0018ExperimentVariant && !isLoadingFTS0017orFTS0018Experiment && productLevel === STARTER && !!productLine;
  const shouldShowFTS0017orFTS0018RecommendedBadge = showFTS0017orFTS0018ExperimentFeatures;
  if (shouldShowFTS0017orFTS0018RecommendedBadge) {
    return /*#__PURE__*/_jsx(RecommendedBadge, {});
  }
  if (ownsProductViaBundle) {
    return /*#__PURE__*/_jsx(CurrentPlanTag, {
      message: `pricing-pages-ui.merchCardsV2.badges.OWNED_VIA_BUNDLE.${bundleType}.${productLevel}`
    });
  }
  if (isCurrentPlan) {
    return /*#__PURE__*/_jsx(CurrentPlanTag, {
      message: "pricing-pages-ui.merchCardsV2.badges.CURRENT_PLAN"
    });
  }
  if (currentTrial) {
    return /*#__PURE__*/_jsx(CurrentTrialBadge, {
      message: "pricing-pages-ui.merchCardsV2.badges.CURRENT_TRIAL"
    });
  }
  return null;
};